import React from 'react'
import { CloseCircleFilled } from '@ant-design/icons'
import { Spin } from 'hljd'
import style from './style.module.less'
import { APPROVAL_STATUS } from '@components/Hotel/constant'
import { getAfterFixUrl } from '@components/Hotel/util'

export default ({ src, status, onDelete, isVideo, isLoading }) => {
  const statusText = {
    [APPROVAL_STATUS.WAIT]: '待审核',
    [APPROVAL_STATUS.FAIL]: '审核未通过'
  }

  return (
    <div
      className={`${style.container} ${
        isVideo ? style.videoItem : style.imgItem
      }`}
      style={{ width: isVideo ? 183 : 144 }}
    >
      {onDelete && (
        <CloseCircleFilled className={style.icon} onClick={onDelete} />
      )}
      <div
        className={isVideo ? style.video : style.img}
        style={{ backgroundImage: `url(${getAfterFixUrl(src)})` }}
      >
        {
          // 使用background-image的形式显示图片，以免出现图片加载显示问题
          // src &&
          // <img src={getAfterFixUrl(src)}/>
        }
        {status != APPROVAL_STATUS.PASS && (
          <div className={style[`footer_${status}`]}>
            <span className={style.status}>{statusText[status]}</span>
          </div>
        )}

        {isVideo && <i className={`iconfont icon-bofang ${style.play}`} />}

        {isLoading && <Spin spinning={isLoading} />}
      </div>
    </div>
  )
}
